import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  useEffect(() => {
    // Redirect to main page on 404
    navigate('/', { replace: true });
  }, [navigate]);
  return null;
};

export default NotFound;


